









































































































import { Component, Vue } from 'vue-property-decorator';
import { mapState } from 'vuex';
import ExcelImporter from '@/components/Booking/ExcelImporter.vue';
import BookingCreateCandidateTableItem from './BookingCreateCandidateTableItem.vue';
import BookingCreateBookingCandidateFormFields from './BookingCreateBookingCandidateFormFields.vue';
import _ from 'lodash';
import { BOOKING_PURPOSES } from '@/constants/booking';

@Component({
  components: {
    ExcelImporter,
    BookingCreateCandidateTableItem,
    BookingCreateBookingCandidateFormFields,
  },
  computed: {
    ...mapState('Booking', {
      booking: 'booking',
    }),
    ...mapState('ServiceItem', {
      serviceItems: 'serviceItems',
    }),
  },
})
export default class BookingCreateCandidateTable extends Vue {
  // Booking State
  booking!: Booking;
  isFetching: number[] = [];
  serverInfo = {};
  showAdditionalService = false;
  currentPage = 1;
  itemsPerPage = 10;
  search = '';
  errorMessage = '';

  purposes = BOOKING_PURPOSES;

  get headers() {
    const header = [
      { text: 'Candidate' },
      { text: 'Email', sortable: false },
      { text: 'Phone number', sortable: false },
      { text: 'Department', sortable: false },
    ];

    if (this.showAdditionalService) {
      header.push({ text: 'Additional Services', sortable: false });
    }

    header.push({ text: 'Action', sortable: false });

    return header;
  }

  get disableRemove() {
    return (this.booking.booking_candidates?.length || 0) === 1;
  }

  showSheet = false;

  selectedBookingCandidate = null;
  selectedBookingCandidateIndex: number | null = null;

  removeCandidate(index: number) {
    const bookingCandidateCount = this.booking.booking_candidates?.length || 0;
    if (bookingCandidateCount > 1) {
      this.$store.dispatch('Booking/removeCandidate', index);
    }
    this.$store.dispatch('Booking/syncCandidateNumber');
  }

  preFetch(candidates, index) {
    if (!this.isFetching) {
      return;
    }
    let data = {
      business_oid: this.booking.business_oid,
      booking_candidates: candidates,
    };

    if (!_.isArray(candidates) && !_.isNil(index)) {
      const candidate = candidates;
      data.booking_candidates = [candidate];

      if (![candidate.email, candidate.mobile].some((item) => !!item)) {
        return null;
      }

      if (this.serverInfo[candidate.email]) {
        this.fetchInfo(candidate.email, index);
        return null;
      }

      data = {
        business_oid: this.booking.business_oid,
        booking_candidates: {},
      };

      data['booking_candidates'][index] = candidate;

      this.isFetching.push(index);
    }

    this.$store
      .dispatch('Booking/candidatePreFetch', data)
      .then((response) => {
        const bookingCandidates = response.data.data;
        for (const key in bookingCandidates) {
          const matched = key.match(/\d+/);
          const index = matched ? matched[0] : -1;
          if (bookingCandidates[key]) {
            this.serverInfo[bookingCandidates[key].email] = {
              mobile: bookingCandidates[key].mobile,
              first_name: bookingCandidates[key].first_name,
              last_name: bookingCandidates[key].last_name,
              date_of_birth: bookingCandidates[key].date_of_birth,
              source: bookingCandidates[key].source,
            };

            if (index === key) {
              this.selectedBookingCandidate = this.serverInfo[
                bookingCandidates[key].email
              ];
            }

            this.fetchInfo(bookingCandidates[key].email, index);
          }
        }
      })
      .finally(() => {
        this.isFetching = [];
      });
  }

  fetchInfo(email, index) {
    if (!this.booking.booking_candidates) {
      return;
    }
    if (this.booking.booking_candidates[index].email == '') {
      this.booking.booking_candidates[index].email = email;
    }
    if (this.booking.booking_candidates[index].mobile == '') {
      this.booking.booking_candidates[index].mobile = this.serverInfo[
        email
      ].mobile;
    }
    if (this.booking.booking_candidates[index].first_name == '') {
      this.booking.booking_candidates[index].first_name = this.serverInfo[
        email
      ].first_name;
    }
    if (this.booking.booking_candidates[index].last_name == '') {
      this.booking.booking_candidates[index].last_name = this.serverInfo[
        email
      ].last_name;
    }
    if (this.booking.booking_candidates[index].date_of_birth == '') {
      this.booking.booking_candidates[index].date_of_birth = this.serverInfo[
        email
      ].date_of_birth;
    }
    this.booking.booking_candidates[index].source = this.serverInfo[
      email
    ].source;
  }

  updateBookingCandidate(bookingCandidate) {
    if (
      _.isNull(this.selectedBookingCandidateIndex) ||
      !this.booking.booking_candidates
    ) {
      return;
    }
    for (const key in bookingCandidate) {
      this.booking.booking_candidates[this.selectedBookingCandidateIndex][key] =
        bookingCandidate[key];
    }
  }

  updateBookingCandidates(bookingCandidates: []) {
    this.isFetching = [];
    this.booking.booking_candidates = bookingCandidates.map(
      (candidate) => candidate
    );
    this.$store.dispatch('Booking/syncCandidateNumber');
  }

  filterCandidate(value, search, item) {
    return Object.keys(item).some((k) => {
      return (
        [
          'first_name',
          'last_name',
          'date_of_birth',
          'mobile',
          'email',
        ].includes(k) &&
        item[k]
          .toString()
          .toLowerCase()
          .includes(search)
      );
    });
  }
}
